// extracted by mini-css-extract-plugin
export default {"box":"AboutUs_box__ATnqp","logos":"AboutUs_logos__hNOcp","img":"AboutUs_img__dY8p3","back":"AboutUs_back__U2U5B","hideMobile":"AboutUs_hideMobile__UaXmd"};